<template>
  <div>
    <div v-if="!stellen.length > 0">
      &nbsp;
    </div>
    <div v-else>
      <v-list two-line>
        <v-slide-x-reverse-transition
          class="py-0"
          group
          tag="v-list"
        >
          <template v-for="(item, index) in stellen">
            <v-list-tile
              :key="item.id"
              avatar
              ripple
              class="stellencard auto-height"
              :class="{ eigenestelle: item.eigenestelle }"
              :to="{ name: 'stellenanzeige', params: { id: item.slug }}"
            >
              <v-list-tile-avatar
                tile
                class="pr-4"
              >
               
                <v-icon>person</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content class="pr-2">
                <v-list-tile-title 
                  class="text-truncate font-weight-regular stellenheight pr-3" :class="ÜberschriftSize">
                  {{ item.titel }}
                </v-list-tile-title>
                  <v-list-tile-sub-title v-if="meinestellen" class="subheading mt-2">
                   <stellen-liste-sichtbarkeit :status="item.status"></stellen-liste-sichtbarkeit> 
                  </v-list-tile-sub-title>
                <!-- <v-list-tile-sub-title v-else class="subheading mt-2">
                 {{ item.betrieb.name }}  in {{ item.betrieb.stadt }} {{ item.betrieb.stadtteil }} ({{ item.betrieb.plz }})
                </v-list-tile-sub-title> -->
              </v-list-tile-content>

              <v-list-tile-action v-if="item.frist" class="text-xs-right" :class="TimeagoschriftSize">
               <v-btn :to="{name: 'stellenedit', params: { id: item.slug }}" flat v-if="item.eigenestelle" class="pa-2">
                <v-icon color="secondary" left>settings</v-icon> ändern
              </v-btn>
                <timeago v-else :datetime="item.frist"></timeago>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider
              inset
              v-if="index + 1 < stellen.length"
              :key="index + 'index'"
            ></v-divider>
          </template>
        </v-slide-x-reverse-transition>
        <span v-if="startseite">
          <v-divider inset></v-divider>
          <v-list-tile
            avatar
            class="stellencard"
            :to="{ name: 'stellen' }"
          >
            <v-list-tile-content class="pr-2">
              <v-list-tile-title
                class="pr-5 pt-2 text-xs-center"
                style="height: 80px;"
              >
                <v-btn
                  large
                  color="secondary"
                  class="title text-none"
                >
                  <v-icon
                    left
                    dark
                  >list_alt</v-icon>
                {{ StellenText }}
                </v-btn>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </span>
      </v-list>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
// import AnfrageVerstecken from '~/components/anfragen/AnfrageVerstecken.vue'
import StellenListeSichtbarkeit from '~/components/stellen/StellenListeSichtbarkeit.vue'

export default {
  props: {
    startseite: {
      type: Boolean,
      default: false
    },
    meinestellen: {
      type: Boolean,
      default: false
    },
    stellen: {
      type: Array,
      required: true
    }
  },
  components: {
    StellenListeSichtbarkeit
  },

  data () {
    return {
      // loading: true
    }
  },
  computed: {
    ÜberschriftSize: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'subheading'
      } else {
        return 'headline'
      }
    },
    TimeagoschriftSize: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'caption'
      } else {
        return 'regular'
      }
    },
    StellenText: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'Alle Angebote'
      } else {
        return 'Alle Job- & Ausbildungsangebote'
      }
    }
  },
  mounted: function () {},
  methods: {
    TrueTransform: function (value) {
      if (value === true) {
        return 'gewünscht'
      } else {
        return value
      }
    }
  }
}
</script>

<style >
/* .v-list__tile {
  height: 90px !important;
}

.v-list__tile__title {
  height: auto;
} */

/* .overrideClass > .v-list__tile {
  height: 200px;
} */
.v-list .auto-height .v-list__tile {
  height: 100px !important;
}
.stellenheight {
  height: 28px;
}
.eigenestelle {
  background-color: #EEEEEE;
}
/* 
.v-list__tile--avatar {
  height: 120px !important;
}
.v-list--two-line .v-list__tile {
    height: auto;
} */
</style>